import { css, type Theme } from '@emotion/react';

export const illustrations = (theme: Theme) => css`
  z-index: 3;

  @media (max-width: ${theme.breakpoints.large}) {
    display: none;
  }
`;

export const manRunning = css`
  transform: rotate(-1.66);
  position: absolute;
  bottom: 105px;
  left: 117px;
`;

export const womanStaring = css`
  transform: rotate(-4.54);
  position: absolute;
  right: 146px;
  bottom: 240px;
`;

export const waves = css`
  position: fixed;
  bottom: 0px;
  left: 0px;
  right: 0px;
  line-height: 0;
  z-index: 2;
`;
